/* global Swiper */

/**
 * Initialize Swiper slider for testimonial block
 * @param {HTMLElement} block - The testimonial block
 * @param {Object} breakpoints - The breakpoints for the slider
 * @return {void}
 */
const initializeSwiper = ( block, breakpoints ) => {

	let swiperInstance;
	if ( !swiperInstance ) {

		swiperInstance = new Swiper( block.querySelector( ".swiper" ), {
			loop: false,
			speed: 800,
			grabCursor: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			preloadImages: true,
			lazy: true,
			allowTouchMove: true,
			breakpoints: breakpoints,
			spaceBetween: 0,
			centeredSlides: false,
			slidesOffsetAfter: 40,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		} );

	}

};
const breakpoints = {
	0: {
		spaceBetween: 0,
		slidesPerView: 1.1,
	},
	800: {
		spaceBetween: 0,
		slidesPerView: "auto",
	},
};

document.querySelectorAll( ".b-cards-slider" ).forEach( ( block ) => {

	initializeSwiper( block, breakpoints );

} );
